import { createContext } from 'react'
import type { AuthUser } from 'aws-amplify/auth'

export type User = {
  userId: string
  username: string
  email: string
  emailVerified: boolean
  userGroups: string[]
  signInDetails?: AuthUser['signInDetails']
}

type UserContextType = {
  user: User | undefined
  updateUser: (u: User) => void
}

const UserContext = createContext<UserContextType>({
  user: undefined,
  updateUser: (): void => {},
})

export default UserContext
